export const name = "FORMAT_DATE";
export const summary = `Formats a \`DATE\` value according to a specified format string.`;
export const reference = `
## FORMAT_DATE

Formats a \`DATE\` value according to a specified format string.

\`\`\`
FORMAT_DATE(format_string, date_expr)
\`\`\`

### Description

Formats a \`DATE\` value according to a specified format string.


### Definitions

- \`format_string\`: A \`STRING\` value that contains the format elements to use with \`date_expr\`.
- \`date_expr\`: A \`DATE\` value that represents the date to format.


### Return Data Type

\`STRING\`


### Examples



\`\`\`
SELECT FORMAT_DATE('%x', DATE '2008-12-25') AS US_format;

/*------------*
 | US_format |
 +------------+
 | 12/25/08 |
 *------------*/
\`\`\`



\`\`\`
SELECT FORMAT_DATE('%b-%d-%Y', DATE '2008-12-25') AS formatted;

/*-------------*
 | formatted |
 +-------------+
 | Dec-25-2008 |
 *-------------*/
\`\`\`



\`\`\`
SELECT FORMAT_DATE('%b %Y', DATE '2008-12-25') AS formatted;

/*-------------*
 | formatted |
 +-------------+
 | Dec 2008 |
 *-------------*/
\`\`\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/date_functions
`;
